import React, {Component} from 'react';
import './styles.less';
import {Modal, Row, Col, Button} from 'antd';
import {CloseCircleFilled} from '@ant-design/icons';
import {PATH} from '../../../constants';
import SuccessCreated from '../../../assets/icons/success-banner.png';
import PasswordChanged from '../../../assets/images/password-success.svg';

const CloseIcon = (
  <CloseCircleFilled style={{fontSize: 20, color: '#121432'}} />
);

class SuccessModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.baseState = this.state;
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.visible === true && this.props.visible === false) {
      console.log('---- 11111111111111111111111111111111111111 ----');
      // this.formRef.current.resetFields();
      this.setState(this.baseState);
    }
  }

  renderFooter = () => {
    const {text = '', buttonText = ''} = this.props;
    return (
      <div className="text-container">
        <span className="mb12">{text}</span>
        {buttonText && (
          <div className="w100 mb8 flex justify-content-center">
            <Button
              className="zast-primary-btn dark-blue"
              onClick={this.goToPage}>
              {buttonText}
            </Button>
          </div>
        )}
      </div>
    );
  };

  goToPage = () => {
    const {type = 'success'} = this.props;
    const {url = ''} = this.props;
    type === 'password' && this.props.history.goBack();
    this.props.close();
  };

  render() {
    const {visible, close, loading = false, type = 'success'} = this.props;
    return (
      <Modal
        centered
        visible={visible}
        onCancel={close}
        className={'bookings-success-modal'}
        // confirmLoading={requesting}
        destroyOnClose={true}
        closeIcon={CloseIcon}
        closable={type === 'password' ? false : true}
        maskClosable={type === 'password' ? false : true}
        width={'50%'}
        title={null}
        footer={this.renderFooter()}>
        <div className="image-container">
          <img
            src={type === 'password' ? PasswordChanged : SuccessCreated}
            className={`success-image ${type === 'password' ? '' : 'w100'}`}
            alt="success-img"
          />
        </div>
      </Modal>
    );
  }
}

export default SuccessModal;
